module.exports = __webpack_public_path__ + "assets/img/component_v_model.6f828f15.jpg";